// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__F9cnF","button":"Button_button__vLB1y","outline":"Button_outline__uSAKS"};